export default function wrapSeoLead() {
    let seoLead = document.querySelector(".seo-section .content");
    if (!seoLead) {
        return;
    }

    let seoLeadWrapper = seoLead.querySelector(".content--wrapper");
    let seoLeadContent = seoLead.querySelector(".seo-content");
    
    seoLead.classList.remove("open");
    seoLead.classList.remove("overflow");
    
    if (seoLeadWrapper.getBoundingClientRect().height <  seoLeadContent.getBoundingClientRect().height) {
        seoLead.classList.add("overflow");
        let opener = seoLead.querySelector(".seo-lead--opener");

        if (opener) {
            opener.addEventListener("click", function() {
                seoLead.classList.add("open");
            });
        }
    } else {
        seoLead.classList.remove("overflow");
        seoLead.classList.add("open");
    }
}